import React from 'react';
import { useLoaderData } from 'react-router-dom';
import Button from '../../components/Button';


const PortfolioDetails = () => {
    const data = useLoaderData()
    const {body,imageUrl,name}= data
    
   
    return (
        <div className='min-h-screen w-full px-10 py-20'>
<img src={imageUrl} alt="" />


<div className='infos my-8'>

<h2 className='text-3xl font-extrabold mb-6'>{name}</h2>

<Button>Live Link</Button>
<Button>Client</Button>
<Button>server</Button>

</div>
           
           {/* body */}
           <div className="bodyText" dangerouslySetInnerHTML={{__html: body}}></div>
        </div>
    );
};

export default PortfolioDetails;